<template>
  <div>
    <b-card header-tag="header" class="m-4" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">
            Cadastrar Protocolo
          </span>
          <btn-voltar />
          <b-button id="btnCadastrarProcolo" class="float-right m-1" size="sm"
            :disabled="Boolean(desabilitarBtnCadastrar)" @click="abrirModalAssinatura()">
            <font-awesome-icon icon="save" />
            Cadastrar
          </b-button>
          <b-button id="btnDescartarProtocolo" class="float-right m-1" size="sm" :disabled="rascunho === null"
            @click="perguntarLimparRascunho()">
            <font-awesome-icon icon="times" />
            Descartar
          </b-button>
        </h6>
      </template>

      <b-container fluid class="p-0">
        <b-tabs card>
          <b-tab title="Dados do protocolo" active>
            <b-row>
              <b-col xs="12" md="12" lg="8" xl="4" class="wrapper-multiselect-sagres">
                <b-form-group id="ug-input-group" label-align="left" label="Unidade Gestora *" label-for="type">
                  <multiselect v-model="ug" open-direction="bottom" class="w-100" :close-on-select="true"
                    :searchable="true" label="Nome" :show-labels="false" deselect-label="" :allow-empty="false"
                    :disabled="Boolean(isLogadoUg)" placeholder="Selecione" track-by="Codigo" :options="ugs">
                    <template slot="noOptions">
                      <small><i>Erro ao obter dados.</i></small>
                    </template>
                    <template slot="noResult">
                      <i>Sem resultados.</i>
                    </template>
                  </multiselect>
                </b-form-group>
              </b-col>

              <b-col xs="12" md="12" lg="8" xl="4">
                <b-form-group id="responsavel-input-group" label="Responsável principal" label-for="input-responsavel"
                  label-align="left">
                  <b-form-input v-if="responsavel" id="input-responsavel" class="w-100" v-model="responsavel.Nome"
                    disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" md="12" lg="4" xl="4">
                <b-form-group id="tpDocumento-input-group" label-align="left" label="Tipo de Documento *"
                  label-for="type">
                  <multiselect id="multiSelectTipoDocumentoCriarProtocolo" data-cy='selectFieldCriarProtocolo'
                    v-model="tipoDocSelecionado" @input="onChangeTipoDocumento" open-direction="bottom" class="w-100"
                    :close-on-select="true" :searchable="true" label="Descricao" :show-labels="false" deselect-label=""
                    :allow-empty="false" placeholder="Selecione" track-by="Cod" :options="tiposDocsPublicos">
                    <template slot="noOptions">
                      <small><i>Erro ao obter dados.</i></small>
                    </template>
                    <template slot="noResult">
                      <i>Sem resultados.</i>
                    </template>
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col xs="12" md="12" lg="4" xl="4">
                <b-form-group id="flCompensacao-radio-group" label-align="left" label="Possui compensação financeira?"
                  label-for="radio-flCompensacao" v-if="tipoDocSelecionado && tipoDocSelecionado.Fl_previdencia">
                  <b-form-radio-group class="text-left" v-model="flCompensacao" :state="Boolean(flCompensacao)"
                    :options="flCompensacaoOptions" id="radio-flCompensacao" @change="salvarRascunho()">
                    <b-form-invalid-feedback :state="Boolean(flCompensacao)">Selecione uma opção
                    </b-form-invalid-feedback>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" md="12" lg="8" xl="8">
                <b-form-group class="formGroup" id="assunto-textarea-group" label="Assunto *"
                  label-for="textarea-Assunto" label-cols="auto" content-cols="12" v-if="rascunho">
                  <b-form-textarea v-if="rascunho" id="textarea-Assunto" v-model="assunto"
                    placeholder="Digite um assunto..." :state="Boolean(assunto) && !tamanhoInvalidoAssunto" @blur="onBlurAssunto" rows="3"
                    max-rows="6"></b-form-textarea>
                  <b-form-invalid-feedback v-if="tamanhoInvalidoAssunto" state="error">
                    {{ `São permitidos ${assuntoMaxLength} caracteres. O limite foi excedido em ${assunto.length - assuntoMaxLength} caractere(s).` }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Anexos - Atos" v-if="rascunho">
            <b-row>
              <b-col>
                <b-button class="float-right mb-3" @click="abrirModalNovoAto()">
                  <font-awesome-icon icon="plus" class="mr-2" />
                  Anexar Ato
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" md="12" lg="12" xl="12">
                <b-table id="table-atos" striped hover :items="atos" :fields="fieldsAtos" small show-empty
                  no-border-collapse>
                  <template #empty>
                    <span>Não foram encontrados dados.</span>
                  </template>
                  <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-dark">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong class="loading-text">Carregando...</strong>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <div v-if="false">
                      <span class="">{{}}</span>
                    </div>
                    <div v-else class="actions-icons">
                      <BtnDownload :fazerDownload="downloadArquivo" texto="Baixar Ato" :parametros="row.item"
                        :key="row.item.IdArquivo" />
                      <b-link class="text-dark" @click="confirmarExclusaoAnexo(row.item)">
                        <font-awesome-icon icon="trash" />
                        <div style="font-size: 12px">Remover</div>
                      </b-link>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Anexos - Multimídias" v-if="rascunho">
            <b-row>
              <b-col>
                <b-button id="btnAnexarMultimidiaCadastrarProcolo" class="float-right mb-3"
                  @click="abrirModalNovoMultimidia()">
                  <font-awesome-icon icon="plus" class="mr-2" />Anexar
                  Multimídia
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" md="12" lg="12" xl="12">
                <b-table id="table-multimidias" striped hover :items="multimidias" :fields="fieldsMultimidia" small
                  show-empty no-border-collapse>
                  <template #empty>
                    <span>Não foram encontrados dados.</span>
                  </template>
                  <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-dark">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong class="loading-text">Carregando...</strong>
                    </div>
                  </template>
                  <template #cell(actions)="row">
                    <div v-if="false">
                      <span class="">{{}}</span>
                    </div>
                    <div v-else class="actions-icons">
                      <BtnDownload :fazerDownload="downloadArquivo" texto="Baixar Multimídia" :parametros="row.item"
                        :key="row.item.IdArquivo" />
                      <b-link class="text-dark" @click="confirmarExclusaoAnexo(row.item)">
                        <font-awesome-icon icon="trash" />
                        <div style="font-size: 12px">Remover</div>
                      </b-link>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-container>
    </b-card>
    <b-modal id="upload-ato-modal" button-size="sm" centered header-bg-variant="secondary" header-text-variant="light"
      header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc>
      <template #modal-header="">
        <h5>Anexar Ato</h5>
      </template>
      <b-form-file v-model="novoArquivo" :state="Boolean(novoArquivo)" accept=".pdf, .zip"
        placeholder="Escolha um arquivo..." class="mt-3"></b-form-file>

      <b-form-select id="select-tpAto" data-cy="selectFieldAnexarAto" v-model="novoTipoAto"
        :state="Boolean(novoTipoAto)" :options="listaTipos(tiposAtoLiberados)" class="mt-3">
      </b-form-select>

      <template #modal-footer="">
        <b-button size="sm" @click="adicionarAto()" :disabled="novoArquivo === null || novoTipoAto === null">
          Adicionar
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalNovoAto()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="upload-multimidia-modal" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop
      no-close-on-esc>
      <template #modal-header="">
        <h5>Anexar Multimídia</h5>
      </template>
      <b-form-file v-model="novoArquivo" :state="Boolean(novoArquivo)" :accept="tiposMultimidia"
        placeholder="Escolha um arquivo..." class="mt-3"></b-form-file>

      <template #modal-footer="">
        <b-button size="sm" @click="adicionarMultimidia()" :disabled="novoArquivo === null">
          Adicionar
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalNovoMultimidia()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="assinatura-modal" size="md" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop
      no-close-on-esc>
      <template #modal-header="">
        <h5>Assinar Anexos</h5>
      </template>

      <b-row>
        <b-col cols="6" class="">
          <b-form-group id="input-group-type" label-size="md" label="Tipo" label-for="type">
            <b-form-select v-model="type">
              <b-form-select-option value="S" selected>Senha</b-form-select-option>
              <b-form-select-option value="T">Token</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" class="">
          <b-form-group v-if="type === 'S'" id="input-group-password" label-size="md" label="Senha"
            label-for="password">
            <b-form-input type="text" style="width: 0; height: 0; padding: 0; border: 0"></b-form-input>
            <b-form-input id="passwdSenhaCadastrarAnexo" v-model="senha" type="password"
              autocomplete="new-password"></b-form-input>
          </b-form-group>
          <b-form-group v-else id="input-group-type" label-size="md" label="Certificado" label-for="type">
            <b-form-select v-model="thumbprint">
              <b-form-select-option value="0" disabled selected>Selecione</b-form-select-option>
              <b-form-select-option v-for="cert in certificados" :key="cert.thumbprint" :value="cert.thumbprint">{{
                cert.subjectName
              }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-progress :value="curValueBar" :max="maxValueBar" v-if="maxValueBar" class="w-50"></b-progress>
        <b-button id="btnConfirmarAssinarAnexos" size="sm" :disabled="showLoading" variant="secondary"
          @click="confirmar()" class="w-25">
          <b-spinner v-if="showLoading" small />
          Confirmar
        </b-button>
        <b-button size="sm" variant="outline-secondary" :disabled="showLoading" @click="cancelarAssinatura(cancel)" class="w-20">
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>


<script>
import protocoloService from "@/services/processos-eletronicos/protocoloService";
import ugService from "@/services/administracao/ugService";
import { store } from "@/store";
import Multiselect from "vue-multiselect";
import BtnDownload from "@/components/shared/btn-download";
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import LacunaWebPKI from "web-pki";
import { UtilsTS } from '@/utilsts';
import { trackProtocoloMatomoEvent } from "@/utils/matomo";

export default {
  name: "CriarProtocolo",
  mixins: [UtilsTS],
  components: {
    Multiselect,
    BtnDownload,
    BtnVoltar,
  },
  data() {
    return {
      ugs: [],
      ug: null,
      assunto: null,
      tiposDocsPublicos: [],
      tiposMultimidia: '.mp3, .mp4',
      rascunho: null,
      tipoDocSelecionado: null,
      novoTipoAto: null,
      responsavel: null,
      tiposAtos: [],
      comboTiposAtos: [],
      atos: [],
      multimidias: [],
      flCompensacao: null,
      flCompensacaoOptions: [
        { text: "Sim", value: "S" },
        { text: "Não", value: "N" },
      ],
      fieldsAtos: [
        {
          key: "NomeArquivo",
          label: "Arquivo",
        },
        {
          key: "TpArqStr",
          label: "Tipo",
        },
        {
          key: "actions",
          label: "Ações",
          tdClass: ["align-middle", "col-actions"],
          thClass: "text-center",
        },
      ],
      fieldsMultimidia: [
        {
          key: "NomeArquivo",
          label: "Arquivo",
        },
        {
          key: "actions",
          label: "Ações",
          tdClass: ["align-middle", "col-actions"],
          thClass: "text-center",
        },
      ],
      itemDelete: null,
      mostrarModalAtos: false,
      novoArquivo: null,

      //modal assinatura
      type: "S",
      showLoading: false,
      senha: "",
      thumbprint: 0,
      pki: null,
      tokens: [],
      certificados: null,
      //barra de progresso de assinatura
      curValueBar: null,
      maxValueBar: null,
      novoProtocolo: null,
      listarCertificados: null,

      assuntoMaxLength: 2000
    };
  },
  computed: {
    tiposAtoLiberados() {
      if(this.atos.length < 1) {
        return this.comboTiposAtos.filter(cta => cta.text !== 'ANEXO')
      }
      return this.comboTiposAtos
    },
    desabilitarBtnCadastrar() {
      return (
        this.rascunho === null ||
        this.rascunho.Assunto === null ||
        this.assunto === null ||
        this.assunto === "" ||
        !this.tipoDocSelecionado ||
        (this.tipoDocSelecionado.Fl_previdencia &&
          this.flCompensacao == null) ||
        this.atos.length + this.multimidias.length === 0 ||
        this.tamanhoInvalidoAssunto
      );
    },
    tamanhoInvalidoAssunto() {
      return Boolean(this.assunto) && this.assunto.length > this.assuntoMaxLength
    }
  },
  methods: {
    trackProtocoloEvent(action, name) {
      trackProtocoloMatomoEvent(action, name);
    },
    listaTipos(tipos) {
      const tiposValidos = tipos.filter(e => e.value !== null)
      if (tiposValidos.length == 1) {
        this.novoTipoAto = tiposValidos[0].value
      }
      return tiposValidos
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async downloadArquivo(arquivo) {
      const response = await protocoloService.downloadArquivoRascunho(
        arquivo.IdProtocolo,
        arquivo.IdArquivo
      );
      if (response && response.status == 200) {
        this.download(arquivo.NomeArquivo, response.data);
      } else {
        if (response && response.data) {
          let respText = JSON.parse(await response.data.text())
          this.$toast.error(respText.msg)
        }
        else this.$toast.error("Erro ao obter o arquivo");
      }
    },
    async onChangeTipoDocumento() {
      store.blockScreen = true;
      await this.listarTiposAtoMultimidia(this.tipoDocSelecionado.Cod);
      this.flCompensacao = null;
      try {
        await this.salvarRascunho();
      } catch (e) {
        await this.carregarTiposDocsPublicos();
      } finally {
        store.blockScreen = false;
      }
    },
    async onBlurAssunto() {
      if (this.assunto.length <= this.assuntoMaxLength && this.compareTexto(this.assunto, this.rascunho.Assunto))
        await this.salvarRascunho();
    },

    compareTexto(c1, c2) {
      if (c1 === "") c1 = null;
      if (c2 === "") c2 = null;
      return (
        (c1 === null && c2 !== null) ||
        (c1 !== null && c2 === null) ||
        (c1 !== null &&
          c2 !== null &&
          c1.replace(/[^a-z0-9]/g, "") !== c2.replace(/[^a-z0-9]/g, ""))
      );
    },
    getAssunto() {
      if (this.rascunho !== null) {
        this.assunto = this.rascunho.Assunto;
      }
    },
    getFlCompensacao() {
      this.flCompensacao = null;
      if (this.rascunho !== null && this.rascunho.FlCompensacao !== null) {
        if (this.rascunho.FlCompensacao) {
          this.flCompensacao = "S";
        } else {
          this.flCompensacao = "N";
        }
      }
    },
    isLogadoUg() {
      return store.codigoUG !== undefined && store.codigoUG !== null && store.codigoUG !== "";
    },
    async removerRascunho() {
      try {
        store.blockScreen = true
        this.trackProtocoloEvent("descarte_confirmado", "rascunho");
        const data = new FormData();
        data.append("codUg", this.ug.Codigo);
        const response = await protocoloService.removerRascunhoProtocolo(data);
        if (response && response.status === 200) {
          this.trackProtocoloEvent("descarte_sucesso", "rascunho");
          this.limparForm();
        } else {
          this.trackProtocoloEvent("descarte_erro", "resposta_api");
          if (response.data?.msg) this.$toast.error(response.data.msg);
          else this.$toast.error("Erro ao remover rascunho");
        }
      } catch (err) {
        this.trackProtocoloEvent("descarte_erro", "falha_requisicao");
        console.error("Erro ao remover rascunho", err);
        this.$toast.error("Erro ao remover rascunho");
      } finally {
        store.blockScreen = false
      }
    },
    limparForm() {
      this.rascunho = null;
      this.carregarTiposDocsPublicos();
      this.obterResponsavelUg();
      this.assunto = null;
      this.atos = [];
      this.multimidias = [];
      this.novoProtocolo = null;
      this.tokens = [];
      this.senha = "";
    },
    async getRascunhoProtocolo() {
      console.log('--getRascunhoProtocolo', this.ug?.Codigo, this.ug)
      const data = new FormData();
      data.append("codUg", this.ug.Codigo);
      const response = await protocoloService.getRascunhoProtocolo(data);
      if (response && response.status === 200) {
        this.rascunho = response.data;
        console.log('--FIM getRascunhoProtocolo')
        return "rascunho_retomado";
      }

      if (response && response.status === 204) {
        console.log('--FIM getRascunhoProtocolo')
        return "novo";
      }

      if (response?.data?.msg) this.$toast.error(response.data.msg);
      else this.$toast.error("Erro ao recuperar dados");

      console.log('--FIM getRascunhoProtocolo')
      return null;
    },
    async carregarAtosMultimidias() {
      if (
        this.rascunho !== null &&
        this.rascunho.TmpArquivosProtocolo != null
      ) {
        this.atos = this.rascunho.TmpArquivosProtocolo.filter(
          (t) => t.TpArquivo !== 99991
        );
        this.atos.forEach((ato) => {
          ato.TpArqStr = this.tiposAtos.find(
            (t) => t.Cod === ato.TpArquivo
          ).Descricao;
        });
        this.multimidias = this.rascunho.TmpArquivosProtocolo.filter(
          (t) => t.TpArquivo === 99991
        );
      }
    },
    async carregarTiposDocsPublicos() {
      const response = await protocoloService.listarTiposProtocolos();
      if (response && response.status === 200 && Array.isArray(response.data)) {
        this.tiposDocsPublicos = response.data;
        if (this.rascunho !== null && this.rascunho.TpDocumento !== 0) {
          this.tipoDocSelecionado = this.tiposDocsPublicos.find(
            (t) => t.value !== null && t.Cod === this.rascunho.TpDocumento
          );
          await this.listarTiposAtoMultimidia(this.tipoDocSelecionado.Cod);
        } else {
          this.tipoDocSelecionado = null;
        }
      } else {
        if (response.data?.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao recuperar tipos de documentos");
      }
    },
    async obterResponsavelUg() {
      const response = await protocoloService.obterResponsavelUg(
        this.ug.Codigo
      );
      if (response && response.status === 200 && response.data) {
        this.responsavel = response.data;
      } else {
        if (response.data?.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao obter responsável da UG");
      }
    },
    /**
     * Garante que o usuário tenha a UG TCE na lista
     */
    async verificarUGTCE() {
      console.log('--verificarUGTCE chamado, env:', process.env.VUE_APP_CODUG_TCE);
      if (!this.ugs.find(
        (u) => u.Codigo == process.env.VUE_APP_CODUG_TCE
      )) {
        this.ugs.push({ Nome: 'TRIBUNAL DE CONTAS DO ESTADO DE SERGIPE', Codigo: process.env.VUE_APP_CODUG_TCE })
      }
    },
    async obterUgsUsuario() {
      try {
      console.log('--obterUgsUsuario chamado');
      const response = await ugService.obterUgsUsuario();
      console.log('--obterUgsUsuario after chamada ugService.obterUgsUsuario', response);
      if (response && response.status === 200 && Array.isArray(response.data)) {
        console.log('--obterUgsUsuario entrou no if de resposta válida, response.data:', response.data);
        this.ugs = response.data;
        console.log('--obterUgsUsuario antes do verificarUGTCE, ugs:', this.ugs);
        await this.verificarUGTCE()
        console.log('--obterUgsUsuario depois do verificarUGTCE, ugs:', this.ugs);
        this.ugs = this.ugs.sort((a, b) =>
        a.Nome.toLowerCase() < b.Nome.toLowerCase() ? -1 : 1
      );
      console.log('--obterUgsUsuario depois do sort, ugs:', this.ugs);
      } else {
        console.log('--obterUgsUsuario resposta inválida, response:', response);
        if (response.data?.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao obter Ugs");
      }
      console.log('--obterUgsUsuario verificando UG do store, store.codigoUG:', '#' + store.codigoUG+'#');
      if (store.codigoUG !== null && store.codigoUG !== undefined && store.codigoUG !== "") {
        console.log('--obterUgsUsuario store.codigoUG presente, buscando UG na lista, store.codigoUG:', store.codigoUG);
        this.ug = this.ugs.find((u) => u.Codigo == store.codigoUG);
      } else {
        console.log('--obterUgsUsuario store.codigoUG ausente, buscando UG TCE na lista, VUE_APP_CODUG_TCE:', process.env.VUE_APP_CODUG_TCE);
        this.ug = this.ugs.find(
          (u) => u.Codigo == process.env.VUE_APP_CODUG_TCE
        );
      }
      console.log('--obterUgsUsuario UG selecionada, this.ug:', this.ug);
    } finally {
      console.log('--obterUgsUsuario finalizado');
    }
    },
    async listarTiposAtoMultimidia(tpDocumento) {
      const response = await protocoloService.listarTiposAto(tpDocumento);
      if (response && response.status === 200 && Array.isArray(response.data)) {
        this.tiposAtos = response.data;
        await this.carregarComboTiposAto();
      } else {
        if (response.data?.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao obter tipos de ato");
      }
      const responseMult = await protocoloService.listarTiposMultimidia(tpDocumento);
      if (responseMult && responseMult.status === 200 && Array.isArray(responseMult.data)) {
        this.atualizarTiposMultimidia(responseMult.data)
      } else {
        if (responseMult.data?.msg) this.$toast.error(responseMult.data.msg);
        else this.$toast.error("Erro ao obter tipos de multimídia");
      }
    },
    atualizarTiposMultimidia(tipos) {
      this.tiposMultimidia = tipos.map(t => '.' + t.Extensao.trim()).join(', ')
    },
    async carregarComboTiposAto() {
      const tipos = this.tiposAtos;
      this.comboTiposAtos = [
        { value: null, text: "SELECIONE UM TIPO", disabled: true },
        ...tipos.map((t) => {
          return {
            value: t.Cod,
            text: t.Descricao,
          };
        }),
      ];
    },
    async downloadAnexo(arquivo) {
      const response = await protocoloService.downloadArquivoRascunho(
        arquivo.IdProtocolo,
        arquivo.IdArquivo
      );
      if (response && response.status === 200)
        this.download(arquivo.NomeArquivo, response.data);
      else {
        if (response.data?.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao baixar anexo");
      }
    },
    confirmarExclusaoAnexo(item) {
      this.itemDelete = item
      this.$bvModal.msgBoxConfirm(`Tem certeza que deseja remover o arquivo ${this.itemDelete?.NomeArquivo}?`, {
        buttonSize: 'sm',
        cancelTitle: 'Cancelar',
        cancelVariant: 'outline-secondary',
        centered: true,
        headerBgVariant: 'secondary',
        headerTextVariant: 'light',
        okTitle: 'Excluir',
        title: 'Confirmar remoção',
      }).then(value => {
        if (value) this.removerArquivo()
      }).catch(err => {
        console.error('Erro no modal de remoção de anexo', err)
      })
    },
    abrirModalAssinatura() {
      this.trackProtocoloEvent("cadastro_clicado", "formulario_valido");
      this.$bvModal.show("assinatura-modal");
    },
    cancelarAssinatura(cancel) {
      this.trackProtocoloEvent("cadastro_cancelado", this.type === "S" ? "senha" : "token");
      cancel();
    },
    abrirModalNovoAto() {
      this.$bvModal.show("upload-ato-modal");
    },
    fecharModalNovoAto() {
      this.$bvModal.hide("upload-ato-modal");
      this.novoTipoAto = null;
      this.novoArquivo = null;
    },
    perguntarLimparRascunho() {
      this.trackProtocoloEvent("descarte_clicado", "rascunho");
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja descartar as alterações?', {
        buttonSize: 'sm',
        cancelTitle: 'Cancelar',
        cancelVariant: 'outline-secondary',
        centered: true,
        headerBgVariant: 'secondary',
        headerTextVariant: 'light',
        okTitle: 'Descartar',
        title: 'Confirmar exclusão',
      }).then(value => {
        if (value) this.removerRascunho()
        else this.trackProtocoloEvent("descarte_cancelado", "rascunho");
      }).catch(err => {
        console.error('Erro no modal de limpeza de rascunho', err)
      })
    },
    abrirModalNovoMultimidia() {
      this.$bvModal.show("upload-multimidia-modal");
    },
    fecharModalNovoMultimidia() {
      this.$bvModal.hide("upload-multimidia-modal");
      this.novoArquivo = null;
    },
    async removerArquivo() {
      const tipoAnexo = this.itemDelete?.TpArquivo === 99991 ? "multimidia" : "ato";
      try {
        store.blockScreen = true
        const data = new FormData();
        data.append("codUg", this.ug.Codigo);
        data.append("idArquivo", this.itemDelete.IdArquivo);
        const response = await protocoloService.removerArquivo(data);
        if (response && response.status === 200) {
          this.rascunho = response.data;
          await this.carregarAtosMultimidias();
          this.trackProtocoloEvent("anexo_removido", tipoAnexo);
          this.$toast.success("Removendo arquivo...");
        } else {
          this.trackProtocoloEvent("anexo_remocao_erro", tipoAnexo);
          if (response?.data?.msg) this.$toast.error(response.data.msg);
          else this.$toast.error("Não foi possível remover o arquivo");
        }
        this.itemDelete = null;
      } catch (err) {
        this.trackProtocoloEvent("anexo_remocao_erro", tipoAnexo);
        console.error('Falha ao remover arquivo: ', err)
        this.$toast.error("Não foi possível remover o arquivo")
      } finally {
        store.blockScreen = false
      }
    },
    async adicionarArquivo(isMultimidia) {
      let tamMaximo = 10;
      if (this.novoArquivo.name.toLowerCase().endsWith(".zip")) tamMaximo = 300;

      if (this.novoArquivo.size / 1024 / 1024 > tamMaximo)
        throw `Arquivo "${this.novoArquivo.name}" excede o tamanho máximo permitido (${tamMaximo} MB)`;

      const data = new FormData();
      data.append("arquivo", this.novoArquivo);
      data.append("codUg", this.ug.Codigo);
      data.append("responderNotificacao", false);
      data.append("isMultimidia", isMultimidia);
      if (!isMultimidia) data.append("tipoAto", this.novoTipoAto);
      const response = await protocoloService.uploadArquivo(data);
      if (response && response.status === 200) {
        this.rascunho = response.data;
        this.trackProtocoloEvent("anexo_adicionado", isMultimidia ? "multimidia" : "ato");
        this.$toast.success("Anexando arquivo...");
      } else {
        if (response.data?.msg) throw response.data.msg;
        else throw "Erro ao anexar arquivo";
      }
    },
    async salvarRascunho() {
      const data = new FormData();
      data.append("codUg", this.ug.Codigo);
      data.append("tpDocumento", this.tipoDocSelecionado.Cod);
      if (this.assunto !== null) data.append("assunto", this.assunto);
      if (this.flCompensacao) {
        data.append("flCompensacao", this.flCompensacao === "S" ? true : false);
      }

      let response;
      try {
        response = await protocoloService.salvarRascunho(data);
      } catch (error) {
        this.trackProtocoloEvent("rascunho_erro", "falha_requisicao");
        throw error;
      }

      if (response && response.status === 200) {
        this.rascunho = response.data;
        this.trackProtocoloEvent("rascunho_salvo", "automatico");
        this.$toast.success("Salvando dados...");
      } else {
        let msg;
        if (response?.data?.msg) msg = response.data.msg;
        else msg = "Erro ao salvar dados";

        this.trackProtocoloEvent("rascunho_erro", "resposta_api");
        this.$toast.error(msg);
        throw new Error(msg);
      }
    },
    async adicionarAto() {
      try {
        //Permitir apenas zip ou pdf
        if (
          !this.novoArquivo.name.toLowerCase().endsWith(".pdf") &&
          !this.novoArquivo.name.toLowerCase().endsWith(".zip")
        ) {
          throw `Arquivo "${this.novoArquivo.name}" possui tipo inválido`;
        }
        if (this.novoArquivo.name.length > 100) {
          throw 'Nome do arquivo excede o limite de 100 caracteres';
        }
        await this.adicionarArquivo(false);
        await this.carregarAtosMultimidias();
        this.fecharModalNovoAto();
      } catch (e) {
        this.trackProtocoloEvent("anexo_adicao_erro", "ato");
        this.$toast.error(e);
      }
    },
    async adicionarMultimidia() {
      try {
        //Permitir apenas os tipos presentes na lista de extensões obtida da api
        const extensao = this.novoArquivo.name.substring(this.novoArquivo.name.lastIndexOf('.'))
        if (!this.tiposMultimidia.includes(extensao)) {
          throw `Arquivo "${this.novoArquivo.name}" possui tipo inválido`;
        }
        if (this.novoArquivo.name.length > 100) {
          throw 'Nome do arquivo excede o limite de 100 caracteres';
        }
        await this.adicionarArquivo(true);
        await this.carregarAtosMultimidias();
        this.fecharModalNovoMultimidia();
      } catch (e) {
        this.trackProtocoloEvent("anexo_adicao_erro", "multimidia");
        this.$toast.error(e);
      }
    },
    async assinarComSenha() {
      const data = new FormData();
      data.append("codUg", this.ug.Codigo);
      data.append("senha", this.senha);
      const response = await protocoloService.assinarEnviarProtocolo(data);
      if (response && response.status === 200) {
        this.novoProtocolo = response.data;
        //this.$bvModal.hide('assinatura-modal');
      } else {
        if (response.data?.msg) throw response.data.msg;
        else throw "Erro salvando protocolo";
      }
    },
    async iniciarAssinaturaToken() {
      const data = new FormData();
      data.append("codUg", this.ug.Codigo);
      const response = await protocoloService.iniciarAssinaturaToken(data);
      if (response && response.status === 200) {
        this.tokens = response.data;
      } else {
        if (response.data?.msg) throw response.data.msg;
        else throw "Erro iniciando assinatura de anexos";
      }
    },
    async finalizarAssinaturaToken() {
      let t = { codUg: this.ug.Codigo, sigTokens: this.tokens };
      const response = await protocoloService.finalizarAssinaturaToken(t);
      if (response && response.status === 200) {
        this.novoProtocolo = response.data;
      } else {
        if (response.data?.msg) throw response.data.msg;
        else throw "Erro finalizando assinatura de anexos";
      }
    },
    limparProgressBar() {
      this.curValueBar = null;
      this.maxValueBar = null;
    },
    //modal assinatura
    async confirmar() {
      const data = new FormData();
      this.showLoading = true;
      const tipoAssinatura = this.type == "S" ? "senha" : "token";
      this.trackProtocoloEvent("cadastro_confirmado", tipoAssinatura);
      if (this.type == "S") {
        this.curValueBar = 1;
        this.maxValueBar = 3;
        try {
          await this.assinarComSenha();
          this.curValueBar = 2;
          this.$toast.success(
            `Protocolo ${this.novoProtocolo.CodigoTCE} salvo com sucesso`
          );
          this.trackProtocoloEvent("cadastro_sucesso", "senha");
          this.limparForm();
        } catch (e) {
          console.error("Erro ao confirmar assinatura com senha", e);
          this.trackProtocoloEvent("cadastro_erro", "senha");
          this.$toast.error(e);
        } finally {
          this.showLoading = false;
          this.$bvModal.hide("assinatura-modal");
          this.limparProgressBar();
        }
      } else {
        this.curValueBar = 1;
        this.maxValueBar = 50;
        try {
          await this.iniciarAssinaturaToken();
          this.maxValueBar = 4 + this.tokens.length;
          this.curValueBar++;
          this.preauthorizeSignatures();
        } catch (e) {
          this.trackProtocoloEvent("cadastro_erro", "token_inicio");
          this.$toast.error(e);
          this.showLoading = false;
          this.limparProgressBar();
        }
      }
    },

    async preauthorizeSignatures() {
      this.pki
        .preauthorizeSignatures({
          certificateThumbprint: this.thumbprint,
          signatureCount: this.tokens.length, // number of signatures to be authorized by the user
        })
        .success(() => {
          this.curValueBar++;
          this.signAllWithRestPki(this.tokens.map((t) => t.Token));
        })
        .fail((err) => {
          console.error("Falha no pki.preauthorizeSignatures", err);
          this.trackProtocoloEvent("cadastro_erro", "token_pre_autorizacao");
          this.$toast.error(
            "Falha ao assinar digitalmente. O serviço de assinaturas parece estar offline. Por favor tente novamente em instantes.",
            {
              timeout: 9000,
            }
          );
          this.showLoading = false;
          this.limparProgressBar();
        });
    },
    signAllWithRestPki(tokens) {
      let currentToken = tokens.pop();
      this.pki
        .signWithRestPki({
          token: currentToken,
          thumbprint: this.thumbprint,
        })
        .success((res) => {
          this.curValueBar++;
          if (tokens.length > 0) this.signAllWithRestPki(tokens);
          else this.completeSignature();
        })
        .error((error) => {
          console.error("Falha no signAllWithRestPki", error);
          this.onWebPkiError("Erro ao assinar documento.", error, "token_assinatura");
          this.limparProgressBar();
        });
    },
    async completeSignature() {
      try {
        await this.finalizarAssinaturaToken();
        this.$toast.success(
          `Protocolo ${this.novoProtocolo.CodigoTCE} salvo com sucesso`
        );
        this.trackProtocoloEvent("cadastro_sucesso", "token");
        this.limparForm();
      } catch (e) {
        console.error("Erro ao completar assinatura com token", e);
        this.trackProtocoloEvent("cadastro_erro", "token_finalizacao");
        this.$toast.error(e);
      } finally {
        this.showLoading = false;
        this.$bvModal.hide("assinatura-modal");
        this.limparProgressBar();
      }
    },
    loadCertificates: function () {
      this.pki
        .listCertificates({
          filter: this.pki.filters.isWithinValidity,
        })
        .success((certs) => {
          this.certificados = certs;
          this.listarCertificados = setTimeout(() => {
            this.loadCertificates();
          }, 5000);
        });
    },
    onWebPkiNotInstalled: function (status, msg, arg3, arg4) {
      this.trackProtocoloEvent("cadastro_erro", "webpki_nao_instalado");
      this.$toast.error("Extensão WebPKI não encontrada");
    },
    onWebPkiFail: function (status, msg, arg3, arg4) {
      this.trackProtocoloEvent("cadastro_erro", "webpki_falha");
      this.$toast.error("Extensão WebPKI retornou uma falha.");
      this.limparProgressBar();
    },
    onWebPkiError(message, error, origin) {
      this.trackProtocoloEvent("cadastro_erro", origin || "webpki_erro");
      this.$toast.error("Ocorreu um erro ao executar o WebPKI.");
      this.showLoading = false;
      this.limparProgressBar();
    },
  },

  beforeDestroy() {
    if (this.listarCertificados) clearTimeout(this.listarCertificados);
  },
  async mounted() {
    try {
      store.blockScreen = true;
      await this.obterUgsUsuario();
      console.log('mounted, entre obterUgs e getRascunhoProtocolo');
      const tipoCriacao = await this.getRascunhoProtocolo();
      this.trackProtocoloEvent(
        tipoCriacao ? "criacao_iniciada" : "criacao_erro",
        tipoCriacao || "rascunho_consulta"
      );
      this.getAssunto();
      this.getFlCompensacao();
      await this.obterResponsavelUg();
      await this.carregarTiposDocsPublicos();
      await this.carregarAtosMultimidias();

      this.pki = new LacunaWebPKI(process.env.VUE_APP_LACUNA_LICENSE);
      this.pki.init({
        restPkiUrl: process.env.VUE_APP_REST_PKI_URL,
        ready: this.loadCertificates,
        notInstalled: this.onWebPkiNotInstalled,
        defaultFail: this.onWebPkiError,
      });
    } finally {
      store.blockScreen = false;
    }
  },
};
</script>
<style></style>
